import React from "react";
import Context from "../../../Context";
import visualState from "../../../visualState";
import Blocker from "../../Misc/Blocker";
import CrumbsProvider from "../../Misc/CrumbsProvider";
import Scrollpane from "../../Misc/Scrollpane";
import Searchbox from "../../Misc/Searchbox";
import List from "../../Misc/List";
import TrackerSortings from "./TrackerSortings";
import TrackerListItem from "./TrackerListItem";
import TrackerFilters from "./TrackerFilters";
import TrackerAdd from "./TrackerAdd";
import TrackerAddButton from "./TrackerAddButton";
import TrackerItem from "./TrackerItem";

export default class Tracker extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.vState = new visualState("TrackerSection");

    this.state = {
      pending: false,
      customListKey: "",

      filters: { active: [], default: [] },
      sortings: [],
      search: [],

      filtersVisible: this.vState.read("filtersVisible", false),

      showAdd: false,
      showAddType: null,

      docTypes: [],
    };
  }

  componentDidMount() {
    this.load();
    this.renderButtons();
    this.setDefaultFilters();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.mode !== this.props.mode) {
      this.setDefaultFilters();
    }
    this.renderButtons();
  }

  onPendingStart = () => {
    this.setState({ pending: true });
  };

  onPendingEnd = () => {
    this.setState({ pending: false });
  };

  load = async () => {
    this.setState({
      docTypes: (this.context.user.types || []).filter((t) =>
        t.code.includes(".tracker")
      ),
    });
  };

  onMethodFinish = () => {
    this.setState({ customListKey: this.context.key() });
  };

  toggleVisibleFilters = () => {
    this.setState((state) => {
      this.vState.save({ filtersVisible: !state.filtersVisible });
      let filters = state.filters;
      filters.active = [];
      return { filtersVisible: !state.filtersVisible, filters };
    });
  };

  setDefaultFilters = () => {
    this.setState((state) => {
      let filters = state.filters;
      filters.default = [];
      if (this.props.mode) {
        if (this.props.mode === "cruise") {
          filters.default.push({
            lstr: "(",
            field: "typecode",
            compare: "EQL",
            value: "cruise.tracker",
            rstr: ")",
          });
        }

        if (this.props.mode === "parking") {
          filters.default.push({
            lstr: "(",
            field: "typecode",
            compare: "EQL",
            value: "parking.tracker",
            rstr: ")",
          });
        }
      }
      console.log(filters);
      return filters;
    });
  };

  renderButtons = () => {
    const filtersActive = this.state.filters.length > 0;

    this.context.actionsSet(
      <>
        <button
          title="Отображение фильров"
          onClick={this.toggleVisibleFilters}
          className={`btn btn-icon ${
            this.state.filtersVisible
              ? "bg-light-primary bg-hover-light"
              : "bg-light bg-hover-light-primary"
          }    mr-2`}
        >
          <i
            className={`fa fa-filter  ${
              this.state.filtersVisible && "text-primary"
            }
            ${filtersActive && "text-warning"}
            ${!this.state.filtersVisible && !filtersActive && "text-muted"}
            `}
          ></i>
        </button>
        <TrackerAddButton
          onFinish={this.onAddOpen}
          itemId={this.props.itemId}
          test={"123"}
          types={this.state.docTypes}
        />
      </>
    );
  };

  handleSortings = (sortings) => {
    this.setState({ sortings });
  };

  handleFilters = (changedFilters) => {
    this.setState((state) => {
      let filters = state.filters;
      filters.active = changedFilters;
      return { filters };
    });
  };

  onSearch = (searchValue) => {
    let search = searchValue
      ? [
          {
            lstr: "(",
            field: "label",
            compare: "IKE",
            value: `%${searchValue}%`,
            rstr: ")",
          },
        ]
      : [];
    this.setState({
      search,
    });
  };

  onAddClose = () => {
    this.setState({ showAdd: false });
  };
  onAddOpen = (showAddType) => {
    this.setState({ showAdd: true, showAddType });
  };
  onAddFininsh = (params) => {
    const { id } = params;

    this.setState({ customListKey: this.context.key() });

    this.context.redirect(`/tracker/all/${id}/`);
    this.onAddClose();
  };

  render() {
    const { mode } = this.props;
    const { showAdd, showAddType } = this.state;
    return (
      <>
        <CrumbsProvider title="Операции" />
        <TrackerAdd
          show={showAdd}
          onClose={this.onAddClose}
          onFinish={this.onAddFininsh}
          type={showAddType}
        />
        <div className="row h-100">
          {this.state.filtersVisible ? (
            <div className="col-lg-3 border-right no-print">
              <Scrollpane>
                <Blocker spinnerFixed hAuto on={this.state.pending}>
                  <TrackerFilters
                    handleFilters={this.handleFilters}
                    types={this.state.docTypes}
                  />
                </Blocker>
              </Scrollpane>
            </div>
          ) : null}

          <div className="col-lg-4 no-print border-right">
            <Scrollpane>
              <div className="d-flex mb-4">
                <div className="text-nowrap flex-grow-1 mr-2">
                  <Searchbox onSearch={this.onSearch} />
                </div>
                <TrackerSortings handleSortings={this.handleSortings} />
              </div>
              <List
                listKey="TrackerList"
                path="/tracker/list"
                keyField="id"
                key={this.state.customListKey}
                fulltext={JSON.stringify(this.state.search)}
                search={JSON.stringify(
                  this.state.filters.active.concat(this.state.filters.default)
                )}
                sort={JSON.stringify(this.state.sortings)}
                limit={150}
                hideSinglePageNav={true}
                onLoadStart={this.onPendingStart}
                onLoadEnd={this.onPendingEnd}
                blocker={{ spinnerFixed: true, hAuto: true }}
              >
                <TrackerListItem
                  highlightItem={this.props.itemId}
                  mode={mode}
                  onFinish={this.onMethodFinish}
                />
              </List>
            </Scrollpane>
          </div>
          <div className="col h-100">
            <Scrollpane>
              <TrackerItem
                itemId={this.props.itemId}
                onMethodFinish={this.onMethodFinish}
              />
            </Scrollpane>
          </div>
        </div>
      </>
    );
  }
}
